import { useState, useEffect } from "react";
import { B } from "./design/tokens";

import Navbar            from "./components/website/Navbar";
import HeroSection       from "./components/website/HeroSection";
import Ticker            from "./components/website/Ticker";
import StatsSection      from "./components/website/StatsSection";
import ServicesSection   from "./components/website/ServicesSection";
import AboutSection      from "./components/website/AboutSection";
import ProcessSection    from "./components/website/ProcessSection";
import PortfolioSection  from "./components/website/PortfolioSection";
import TestimonialsSection from "./components/website/TestimonialsSection";
import CoverageSection   from "./components/website/CoverageSection";
import InsightsSection   from "./components/website/InsightsSection";
import CTABanner         from "./components/website/CTABanner";
import ContactSection    from "./components/website/ContactSection";
import Footer            from "./components/website/Footer";

import AdminPanel        from "./components/admin/AdminPanel";
import IsabelChatbot     from "./components/isabel/IsabelChatbot";
import JdrubioCard        from "./components/cards/JdrubioCard";
import MarivicCard        from "./components/cards/MarivicCard";
import MiraflorrubioCard  from "./components/cards/MiraflorrubioCard";

export default function NESWWebsite() {
  const isAdmin = window.location.pathname === "/admin";
  const [active, setActive] = useState("home");

  const nav = (id) => {
    const el = document.getElementById(id);
    if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); setActive(id); }
  };

  useEffect(() => {
    const sections = ["home", "about", "services", "portfolio", "blog", "contact"];
    const h = () => {
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el) { const r = el.getBoundingClientRect(); if (r.top <= 100 && r.bottom > 100) { setActive(id); break; } }
      }
    };
    window.addEventListener("scroll", h, { passive: true });
    return () => window.removeEventListener("scroll", h);
  }, []);

  if (window.location.pathname === "/jdrubio" || window.location.pathname === "/jrubio") return <JdrubioCard />;
  if (window.location.pathname === "/marivicrubio") return <MarivicCard />;
  if (window.location.pathname === "/miraflorrubio") return <MiraflorrubioCard />;
  if (isAdmin) return <AdminPanel />;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
        *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body { font-family: 'Space Grotesk', sans-serif; -webkit-font-smoothing: antialiased; background: ${B.ink}; }
        ::selection { background: ${B.azure}44; color: ${B.white}; }
        input, textarea, select { font-family: 'Space Grotesk', sans-serif; }
        input::placeholder, textarea::placeholder { color: ${B.slateLight}; }
        @keyframes ticker { from { transform: translateX(0); } to { transform: translateX(-33.333%); } }

        @media (max-width: 1100px) {
          .about-grid    { grid-template-columns: 1fr !important; }
          .coverage-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
          .contact-grid  { grid-template-columns: 1fr !important; }
          .svc-panel     { grid-template-columns: 1fr !important; }
          .footer-grid   { grid-template-columns: 1fr 1fr !important; }
          .stats-grid    { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 768px) {
          .nav-desktop    { display: none !important; }
          .nav-mobile-btn { display: flex !important; }
          .portfolio-grid { grid-template-columns: 1fr !important; }
          .insights-grid  { grid-template-columns: 1fr !important; }
          .process-grid   { grid-template-columns: 1fr 1fr !important; }
          .form-grid      { grid-template-columns: 1fr !important; }
          .footer-grid    { grid-template-columns: 1fr !important; }
          .stats-grid     { grid-template-columns: 1fr 1fr !important; }
          .svc-label      { display: none !important; }
          .process-arrow  { display: none !important; }
        }
        @media (max-width: 540px) {
          .process-grid { grid-template-columns: 1fr !important; }
          .stats-grid   { grid-template-columns: 1fr 1fr !important; }
        }
        @keyframes isabel-pulse {
          0%   { transform: scale(1);    opacity: 0.8; }
          70%  { transform: scale(1.55); opacity: 0;   }
          100% { transform: scale(1.55); opacity: 0;   }
        }
        @keyframes isabel-slide-in {
          from { opacity: 0; transform: translateY(18px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
        @keyframes isabel-dot {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
          40%            { transform: scale(1);   opacity: 1;   }
        }
      `}</style>
      <Navbar active={active} nav={nav} />
      <HeroSection nav={nav} />
      <Ticker />
      <StatsSection />
      <ServicesSection nav={nav} />
      <AboutSection />
      <ProcessSection />
      <PortfolioSection />
      <TestimonialsSection />
      <CoverageSection />
      <InsightsSection />
      <CTABanner nav={nav} />
      <ContactSection />
      <Footer nav={nav} />
      <IsabelChatbot />
    </>
  );
}
